import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    loading: false,
    is_submit_disable: false,
    mode: '',
    quiz_id: null,
    languages: [],
    question: {},

    // Form checking
    form_checking_mode: false,
    required_list: []
  },
  mutations: {
    RESET_QUESTION_DETAIL_DIALOG(state) {
      state.visibility = false
      state.mode = ''
      state.question = {}
    },
    SET_QUESTION_DETAIL_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_QUESTION_DETAIL_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE(state, payload) {
      state.is_submit_disable = payload
    },
    SET_QUESTION_DETAIL_DIALOG_MODE(state, payload) {
      state.mode = payload
    },
    SET_QUESTION_DETAIL_DIALOG_QUIZ_ID(state, payload) {
      state.quiz_id = payload
    },
    SET_QUESTION_DETAIL_DIALOG_LANGUAGES(state, payload) {
      state.languages = payload
    },
    SET_QUESTION_DETAIL_DIALOG_QUESTION(state, payload) {
      state.question = payload
    },

    SET_QUESTION_DETAIL_DIALOG_UPLOADED_FILE(state, payload) {
      state.page_details.contents[payload.language].image_url = payload.urls
    },
    APPEND_QUESTION_DETAIL_DIALOG_FILE_LIST(state, payload) {
      payload.urls.forEach((url) => {
        state.question.contents[payload.language].image_urls.push(url)
      })
    },
    REMOVE_QUESTION_DETAIL_DIALOG_FILE_LIST(state, payload) {
      state.question.contents[payload.language].image_urls.splice(payload.index, 1)
    },

    // Form checking
    SET_QUESTION_DETAIL_DIALOG_FORM_CHECKING_MODE(state, payload) {
      state.form_checking_mode = payload
    },
    SET_QUESTION_DETAIL_DIALOG_REQUIRED_LIST(state, payload) {
      state.required_list = payload
    }
  },
  actions: {
    async initQuestionDetailDialog({ rootState, commit }, payload) {
      try {
        commit('SET_QUESTION_DETAIL_DIALOG_QUESTION', {})
        commit('SET_QUESTION_DETAIL_DIALOG_VISIBILITY', true)
        commit('SET_QUESTION_DETAIL_DIALOG_LOADING', true)
        commit('SET_QUESTION_DETAIL_DIALOG_MODE', payload.mode)
        commit('SET_QUESTION_DETAIL_DIALOG_QUIZ_ID', payload.quiz_id)
        commit('SET_QUESTION_DETAIL_DIALOG_LANGUAGES', payload.languages)

        const device_id = rootState.auth.selected_device
        if (payload.mode === 'add') {
          let template = {
            device_id: device_id,
            title: '"New Question"',
            max_attempt: null,
            show_hints_when_failed: null,
            contents: {}
          }

          payload.languages.forEach((language) => {
            template.contents[language] = {
              text: '',
              speech: '',
              buttons: { num_of_column: 1, values: [] },
              correct_answers: [],
              is_include_image: false,
              image_urls: [],
              hints: ''
            }
          })
          commit('SET_QUESTION_DETAIL_DIALOG_QUESTION', template)
        } else {
          const response = await api.getQuestionDetail({ quiz_id: payload.quiz_id, question_id: payload.question_id })
          if (response.data.success) {
            let question = response.data.data

            question.languages = payload.languages
            payload.languages.forEach((language) => {
              if (!question.contents[language]) {
                question.contents[language] = { text: '', speech: '', buttons: { num_of_column: 1, values: [] }, correct_answers: [], is_include_image: false, image_urls: [], hints: '' }
              } else {
                let length = question.contents[language].buttons.values.length
                let num_of_column = question.contents[language].buttons.num_of_column
                let num_of_row = Math.ceil(length / num_of_column)
                let buttons_needed = num_of_column * num_of_row - length

                for (let i = 0; i < buttons_needed; i++) {
                  question.contents[language].buttons.values.push({ text: null, payload: null })
                }
              }
            })

            commit('SET_QUESTION_DETAIL_DIALOG_QUESTION', question)
          } else throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUESTION_DETAIL_DIALOG_LOADING', false)
      }
    },

    async addQuestion({ state, commit, dispatch }) {
      try {
        commit('SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE', true)
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__EventManager.question.question')),
          loading: true
        })

        const response = await api.createQuestion({ quiz_id: state.quiz_id, params: state.question })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__EventManager.question.question')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_QUESTION_DETAIL_DIALOG')
          dispatch('fetchQuizDetail', state.quiz_id)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    },
    async updateQuestion({ rootState, state, commit, dispatch }) {
      try {
        commit('SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE', true)
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.editing', Vuetify.locale.t('$vuetify.__EventManager.question.question')),
          loading: true
        })

        const device_id = rootState.auth.selected_device
        const response = await api.updateQuestion({ quiz_id: state.quiz_id, question_id: state.question.id, params: { device_id, ...state.question } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.edit', Vuetify.locale.t('$vuetify.__EventManager.question.question')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_QUESTION_DETAIL_DIALOG')
          dispatch('fetchQuizDetail', state.quiz_id)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    },

    async uploadQuestionDetailFiles({ rootState, commit }, payload) {
      try {
        commit('SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE', true)
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', Vuetify.locale.t('$vuetify.__General.image')),
          loading: true
        })

        const device_id = rootState.auth.selected_device
        const form_data = new FormData()
        payload.file_list.forEach((file) => {
          form_data.append('images', file)
        })
        form_data.append('device_id', device_id)

        const response = await api.uploadEventMediaFile({ params: form_data, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response.data.success) {
          commit('APPEND_QUESTION_DETAIL_DIALOG_FILE_LIST', { urls: response.data.data.urls, language: payload.language })
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.upload', Vuetify.locale.t('$vuetify.__General.images')),
            icon: 'check',
            timeout: '2000'
          })
        } else throw Error(response.data.message)
      } catch (error) {
        console.log(error)
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUESTION_DETAIL_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    }
  }
}
